/* =============================================
    Reactレンダリング
============================================= */
// React初期化を検知して静的メニューを切り替える
document.addEventListener('DOMContentLoaded', function() {
  const headerRoot = document.getElementById('header-menu-root');
  const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length && mutation.addedNodes[0].classList.contains('custom-header-menu')) {
              headerRoot.classList.add('header-menu-initialized');
              observer.disconnect();
          }
      });
  });

  observer.observe(headerRoot, {
      childList: true,
      subtree: true
  });
});

/* =============================================
ヘッダー　スクロールによる高さ変化
============================================= */
document.addEventListener('DOMContentLoaded', function() {

  const header = document.querySelector('.custom-header');
  const slideshow = document.getElementById('js-header-hight-change');
  
  if (header) {
    function updateHeaderHeight() {
      // 現在のスクロール位置を取得
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // スライドショー要素が存在する場合はその要素の位置に基づいて処理
      if (slideshow) {
        const slideshowBottom = slideshow.getBoundingClientRect().bottom;
        
        // スライドショーがビューポートの上に移動した場合
        if (slideshowBottom <= 0) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      } 
      // スライドショー要素がない場合
      else {
        if (currentScrollTop > 0) {
          header.classList.add('scrolled');
          console.log('add');
        } else {
          header.classList.remove('scrolled');
          console.log('remove');
        }
      }
    }
    
    window.addEventListener('scroll', updateHeaderHeight, { passive: true });
    updateHeaderHeight();
  }
});

/* =============================================
カスタム関連商品（アニメーション競合防止のため）
============================================= */
class CustomProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('custom-product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          // コンテンツを更新
          this.innerHTML = recommendations.innerHTML;
          
          // アニメーション要素を取得
          const items = this.querySelectorAll('.custom-related-products__item');
          if (items.length > 0) {
            // 初期状態を設定
            gsap.set(items, {
              opacity: 0,
              y: 30
            });

            // フェードインアニメーションを実行
            gsap.to(items, {
              opacity: 1,
              y: 0,
              duration: 0.6,
              stagger: 0.2,
              ease: "power2.out",
              scrollTrigger: {
                trigger: this,
                start: "top 70%",
                toggleActions: "play none none none"
              }
            });
          }
        }

        if (html.querySelector('.custom-related-products__item')) {
          this.classList.add('custom-related-products--loaded');
        }
      })
      .catch((e) => {
        console.error('商品レコメンデーションの読み込みエラー:', e);
      });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    // ScrollTriggerをクリーンアップ
    const triggers = ScrollTrigger.getAll();
    triggers.forEach(trigger => {
      if (trigger.vars.trigger === this) {
        trigger.kill();
      }
    });
  }
}

customElements.define('custom-product-recommendations', CustomProductRecommendations);

/* =============================================
見出しアニメーション
============================================= */
gsap.registerPlugin(ScrollTrigger);

const initTextAnimation = () => {
const textContainers = document.querySelectorAll(".js-section-animation__trigger");

textContainers.forEach((container) => {
const textBox = container.querySelector(".js-section-animation__text");
const textSpan = textBox.querySelector("span");

// テキスト分割
const split = new SplitText(textSpan, {
  type: "chars",
  charsClass: "char",
});

const computedStyle = window.getComputedStyle(textBox);
const paddingLeft = parseInt(computedStyle.paddingLeft);
const paddingRight = parseInt(computedStyle.paddingRight);
const totalPadding = paddingLeft + paddingRight;

// 最終的な幅を計算
const finalWidth = textSpan.offsetWidth + totalPadding;

// トリガーの幅を先に設定
container.style.width = `${finalWidth}px`;

// 初期状態の設定
gsap.set(split.chars, {
  opacity: 0,
});

// テキストボックスの初期幅を設定
const initialWidth = split.chars[0].offsetWidth * 2;
gsap.set(textBox, {
  width: initialWidth,
});

gsap
  .timeline({
    scrollTrigger: {
      trigger: container,
      // markers:true,
      start: "top 80%",
      once: true,
    },
  })
  .to(textBox, {
    opacity: 1,
    width: finalWidth,
    duration: 0.6,
    ease: "power2.inOut",
  })
  .to(
    split.chars,
    {
      opacity: 1,
      duration: 0.6,
      stagger: 0.05,
      ease: "power2.inOut",
    },
    "-=0.6"
  );
});
};

document.addEventListener("DOMContentLoaded", initTextAnimation);

/* =============================================
テキストスライドアニメーション
============================================= */
class TextSlider {
    constructor() {
    this.init();
  }

  setTextSpeed(multiplier) {
    const baseSpeed = 6000;
    return baseSpeed * multiplier;
  }

  initSwiper(slider) {
    return new Swiper(slider, {
      autoplay: {
        delay: 0,
        reverseDirection: false,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      loop: true,
      slidesPerView: "auto",
      speed: this.setTextSpeed(5),
      allowTouchMove: false,
    }).on(
      "slideChange",
      function (swiper) {
        switch (swiper.realIndex) {
          case 3:
          case 4:
            swiper.params.speed = this.setTextSpeed(9);
            break;
          case 5:
          case 6:
            swiper.params.speed = this.setTextSpeed(13);
            break;
          default:
            swiper.params.speed = this.setTextSpeed(5);
            break;
        }
      }.bind(this)
    );
  }

  init() {
    const sliders = document.querySelectorAll(
      ".js-text-slider:not([data-initialized])"
    );

    if (sliders.length === 0) {
      return;
    }

    sliders.forEach((slider) => {
      this.initSwiper(slider);
      slider.dataset.initialized = "true";
    });
  }
  }

document.addEventListener("DOMContentLoaded", () => {
  new TextSlider();
});

/* =============================================
スライドイン・フェードインアニメーション
============================================= */
class BaseAnimation {
constructor() {
    // ScrollTriggerインスタンスを保持する配列
    this.triggers = [];
    this.initialized = false;

    // bindメソッド
    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);
    this.refresh = this.refresh.bind(this);

    // イベントリスナー設定
    window.addEventListener("load", this.init);
    window.addEventListener("beforeunload", this.destroy);

    // スクロール位置の復元時の対応
    if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
    }
}

init() {
    if (this.initialized) return;

    try {
    gsap.registerPlugin(ScrollTrigger);
    this.initialized = true;

    // ScrollTriggerのデフォルト設定
    ScrollTrigger.config({
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize",
    });

    // 初期化後に少し待ってからrefresh
    setTimeout(() => {
        this.refresh();
    }, 100);
    } catch (error) {
    console.warn("Animation initialization failed:", error);
    }
}

destroy() {
    // 登録されているScrollTriggerインスタンスをクリーンアップ
    this.triggers.forEach((trigger) => {
    if (trigger && trigger.kill) {
        trigger.kill();
    }
    });
    this.triggers = [];
    this.initialized = false;
}

refresh() {
    if (!this.initialized) return;

    try {
    ScrollTrigger.refresh();
    } catch (error) {
    console.warn("ScrollTrigger refresh failed:", error);
    // エラー発生時は再初期化を試みる
    this.destroy();
    this.init();
    }
}

// ScrollTriggerインスタンスを登録
registerTrigger(trigger) {
    if (trigger) {
    this.triggers.push(trigger);
    }
}
}

class SlideInAnimation extends BaseAnimation {
constructor() {
    super();
    this.animateElements = this.animateElements.bind(this);
}

init() {
    super.init();

    const triggerElements = document.querySelectorAll(
    ".js-slideIn-trigger:not([data-initialized])"
    );

    if (triggerElements.length === 0) return;

    triggerElements.forEach((triggerEl) => {
    if (triggerEl.isConnected) {
        // DOMに接続されているか確認
        this.setupScrollTrigger(triggerEl);
    }
    });
}

setupScrollTrigger(triggerEl) {
    const slideElements = triggerEl.querySelectorAll(".js-slideIn");
    if (slideElements.length === 0) return;

    try {
    const tl = gsap.timeline({
        scrollTrigger: {
        trigger: triggerEl,
        start: "top 90%",
        // markers:true,
        toggleActions: "play none none none",
        onRefresh: (self) => {
            // トリガー要素が有効か確認
            if (!triggerEl.isConnected) {
            self.kill();
            return;
            }
        },
        },
    });

    tl.fromTo(
        slideElements,
        {
          clipPath: "inset(0% 0% 100% 0%)",
        },
        {
          clipPath: "inset(0% 0% 0% 0%)",
          duration: 0.8,
          stagger: 0.2,
          ease: "power2.inOut",
        }
    );

    this.registerTrigger(tl.scrollTrigger);
    triggerEl.dataset.initialized = "true";
    } catch (error) {
    console.warn("SlideIn animation setup failed:", error);
    }
}

animateElements(triggerEl) {
    const slideElements = triggerEl.querySelectorAll(".js-slideIn");
    if (slideElements.length === 0) return;

    try {
    gsap.set(slideElements, {
        clipPath: "inset(0% 0% 100% 0%)",
    });

    gsap.to(slideElements, {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.8,
        stagger: 0.2,
        ease: "power2.inOut",
    });
    } catch (error) {
    console.warn("Manual slideIn animation failed:", error);
    }
}
}

class FadeInAnimation extends BaseAnimation {
constructor() {
super();
this.animateElements = this.animateElements.bind(this);
}

init() {
super.init();

const triggerElements = document.querySelectorAll(
  ".js-fadeIn-trigger:not([data-initialized])"
);

if (triggerElements.length === 0) return;

triggerElements.forEach((triggerEl) => {
  if (triggerEl.isConnected) {
    this.setupScrollTrigger(triggerEl);
  }
});
}

setupScrollTrigger(triggerEl) {
const fadeElements = triggerEl.querySelectorAll(".js-fadeIn");
if (fadeElements.length === 0) return;

try {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: triggerEl,
      start: "top 70%",
      toggleActions: "play none none none",
      // markers: true,
      onRefresh: (self) => {
        if (!triggerEl.isConnected) {
          self.kill();
          return;
        }
      },
    },
  });

  tl.fromTo(
    fadeElements,
    {
      opacity: 0,
      y: 30,
    },
    {
      opacity: 1,
      y: 0,
      duration: 0.6,
      stagger: 0.2,
      ease: "power2.out",
    }
  );

  this.registerTrigger(tl.scrollTrigger);
  triggerEl.dataset.initialized = "true";
} catch (error) {
  console.warn("FadeIn animation setup failed:", error);
}
}

animateElements(triggerEl) {
  const fadeElements = triggerEl.querySelectorAll(".js-fadeIn");
  if (fadeElements.length === 0) return;

try {
    gsap.set(fadeElements, {
      opacity: 0,
      y: 30,
    });

    gsap.to(fadeElements, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      stagger: 0.2,
      ease: "power2.out",
    });
    } catch (error) {
      console.warn("Manual fadeIn animation failed:", error);
    }
  }
}

// アニメーションの初期化
document.addEventListener("DOMContentLoaded", () => {
  window.slideInAnimation = new SlideInAnimation();
  window.fadeInAnimation = new FadeInAnimation();
});

// ページ遷移時のクリーンアップ
window.addEventListener("unload", () => {
  if (window.slideInAnimation) {
      window.slideInAnimation.destroy();
  }
  if (window.fadeInAnimation) {
      window.fadeInAnimation.destroy();
  }
});
/* =============================================
custom-slideshow
============================================= */
class CustomSlideshow {
  constructor() {
  this.init();
}

initializeSwiper(element) {
  return new Swiper(element, {
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    speed: 2000,
    pagination: {
      el: ".custom-slideshow__swiper-pagination",
      clickable: true,
    },
  });
}

init() {
const slideshowElements = document.querySelectorAll(
  ".custom-slideshow.swiper-container:not([data-initialized])"
);

if (slideshowElements.length === 0) {
  return;
}

slideshowElements.forEach((element) => {
  this.initializeSwiper(element);
  element.dataset.initialized = "true";
});
}
}

document.addEventListener("DOMContentLoaded", () => {
new CustomSlideshow();
});

if (typeof module !== "undefined" && module.exports) {
module.exports = { CustomSlideshow };
}

/* =============================================
custom-look
============================================= */
const initLookSwiper = () => {
  const lookSwiperElement = document.querySelector(".custom-look__swiper");
  if (!lookSwiperElement) return;

  new Swiper(".custom-look__swiper", {
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".custom-look__nav--next",
      prevEl: ".custom-look__nav--prev",
    },
    slidesPerView: 1.72,
    spaceBetween: 13,
    // autoHeight: false,
    speed: 1000,
    touchRatio: 1, // スワイプの感度（1が標準）
    touchAngle: 45, // スワイプを検知する最大角度
    grabCursor: true, // ドラッグ可能なカーソルを表示
    resistance: true, // ドラッグ時の抵抗効果を有効化
    resistanceRatio: 0.85, // 抵抗の強さ（小さいほど抵抗が強い）

    // タッチ・マウス操作の有効化
    simulateTouch: true,
    touchEventsTarget: "wrapper",

    // スムーズなドラッグ操作の設定
    longSwipes: true,
    longSwipesRatio: 0.5, // スワイプでスライドを切り替える距離の比率
    longSwipesMs: 300, // スワイプの時間設定

    // タッチ操作の詳細設定
    touchStartPreventDefault: true,
    touchMoveStopPropagation: true,
    touchReleaseOnEdges: false,

    // 慣性スクロールの設定
    momentumRatio: 1,
    momentumBounce: true,
    momentumBounceRatio: 1,
    });
};

document.addEventListener("DOMContentLoaded", () => {
initLookSwiper();
});

/* =============================================
custom-news
============================================= */
class BaseNewsSection {
  constructor(element) {
      this.container = element;
      this.activeTagButtons = new Set();
      this.tags = this.container.querySelectorAll(".js-news-tag");
      this.articles = this.container.querySelectorAll(".js-news-article");
      this.newsGrid = this.container.querySelector('.custom-news__grid');
      this.isAnimating = false;
      this.init();
  }
  
  init() {
      this.bindEvents();
      this.showLatestArticles();
  }
  
  bindEvents() {
      this.tags.forEach((tag) => {
          tag.addEventListener("click", (e) => this.handleTagClick(e));
      });
  }
  
  async handleTagClick(e) {
      if (this.isAnimating) return;
      this.isAnimating = true;
      
      const targetButton = e.target.closest('.js-news-tag');
      if (!targetButton) return;

      const selectedTag = targetButton.dataset.tag;
      
      if (targetButton.classList.contains('is-active')) {
          console.log('Deactivating current tag');
          this.tags.forEach((tag) => tag.classList.remove("is-active"));
          this.activeTagButtons.clear();
          await this.fadeOutCurrentArticles();
          this.showLatestArticles();
      } else {
          console.log('Activating new tag');
          this.tags.forEach((tag) => tag.classList.remove("is-active"));
          targetButton.classList.add("is-active");
          this.activeTagButtons.clear();
          this.activeTagButtons.add(selectedTag);
          await this.fadeOutCurrentArticles();
          this.showLatestArticlesByTag(selectedTag);
      }
      
      await this.fadeInFilteredArticles();
      this.isAnimating = false;
  }
  
  showLatestArticles() {
      const sortedArticles = Array.from(this.articles)
          .sort((a, b) => {
              const dateA = new Date(a.querySelector('time').dateTime);
              const dateB = new Date(b.querySelector('time').dateTime);
              return dateB - dateA;
          });
      
      
      this.articles.forEach(article => {
          article.style.display = "none";
      });
      
      const articlesToShow = sortedArticles.slice(0, 6);
      
      articlesToShow.forEach(article => {
          article.style.display = "block";
      });
  }
  
  showLatestArticlesByTag(tag) {
      
      const filteredAndSorted = Array.from(this.articles)
          .filter(article => {
              const tags = article.dataset.tags.split(",");
              const hasTag = tags.includes(tag);
              console.log('Article tags:', tags, 'Has tag:', hasTag);
              return hasTag;
          })
          .sort((a, b) => {
              const dateA = new Date(a.querySelector('time').dateTime);
              const dateB = new Date(b.querySelector('time').dateTime);
              return dateB - dateA;
          });
      
      
      this.articles.forEach(article => {
          article.style.display = "none";
      });
      
      const articlesToShow = filteredAndSorted.slice(0, 6);
      
      articlesToShow.forEach(article => {
          article.style.display = "block";
      });
  }
  
  fadeOutCurrentArticles() {
      return new Promise((resolve) => {
          const visibleArticles = Array.from(this.articles).filter(
              (article) => window.getComputedStyle(article).display !== "none"
          );
          
          if (visibleArticles.length === 0) {
              resolve();
              return;
          }
          
          gsap.to(visibleArticles, {
              opacity: 0,
              y: 30,
              duration: 0.3,
              stagger: 0.1,
              ease: "power2.out",
              onComplete: resolve
          });
      });
  }
  
  fadeInFilteredArticles() {
    return new Promise((resolve) => {
        const visibleArticles = Array.from(this.articles).filter(
            (article) => !article.classList.contains('hidden') && !article.classList.contains('filtered')
        );
        
        if (visibleArticles.length === 0) {
            resolve();
            return;
        }
        
        gsap.fromTo(
            visibleArticles,
            {
                opacity: 0,
                y: 30
            },
            {
                opacity: 1,
                y: 0,
                duration: 0.6,
                stagger: 0.2,
                ease: "power2.out",
                onComplete: resolve
            }
        );
    });
}
}

class PageNewsSection extends BaseNewsSection {
  constructor(element) {
      super(element);
      this.loadMoreBtn = this.container.querySelector('.js-load-more');
      this.bindLoadMoreEvents();
  }
  
  bindLoadMoreEvents() {
      if (this.loadMoreBtn) {
          this.loadMoreBtn.addEventListener('click', () => this.loadMore());
      }
  }
  
  showLatestArticles() {
      const sortedArticles = Array.from(this.articles)
          .sort((a, b) => {
              const dateA = new Date(a.querySelector('time').dateTime);
              const dateB = new Date(b.querySelector('time').dateTime);
              return dateB - dateA;
          });
      
      sortedArticles.forEach((article, index) => {
          if (index < 8) {
              article.classList.remove('hidden');
              article.classList.remove('filtered');
              // 初期表示時は opacity を 1 に設定
              article.style.opacity = '1';
          } else {
              article.classList.add('hidden');
              article.classList.remove('filtered');
              // 非表示記事の opacity を 0 に設定
              article.style.opacity = '0';
          }
      });
      
      this.updateLoadMoreButton();
  }
  
  showLatestArticlesByTag(tag) {
      const filteredArticles = Array.from(this.articles)
          .filter(article => {
              const tags = article.dataset.tags.split(",");
              return tags.includes(tag);
          })
          .sort((a, b) => {
              const dateA = new Date(a.querySelector('time').dateTime);
              const dateB = new Date(b.querySelector('time').dateTime);
              return dateB - dateA;
          });
      
      this.articles.forEach(article => {
          article.classList.add('hidden');
          article.classList.add('filtered');
          // すべての記事の opacity を 0 に設定
          article.style.opacity = '0';
      });
      
      filteredArticles.forEach((article, index) => {
          article.classList.remove('filtered');
          if (index < 8) {
              article.classList.remove('hidden');
              // 表示する記事の opacity を 1 に設定
              article.style.opacity = '1';
          } else {
              article.classList.add('hidden');
          }
      });
      
      this.updateLoadMoreButton();
  }
  
  async loadMore() {
      if (this.isAnimating) return;
      this.isAnimating = true;

      const hiddenArticles = Array.from(this.container.querySelectorAll('.js-news-article.hidden:not(.filtered)'));
      
      // 記事を表示（hidden クラスを削除）
      hiddenArticles.forEach(article => {
          article.classList.remove('hidden');
      });

      // フェードインアニメーション
      await this.animateArticles(hiddenArticles);
      
      this.updateLoadMoreButton();
      this.isAnimating = false;
  }

  animateArticles(articles) {
      return new Promise((resolve) => {
          gsap.fromTo(
              articles,
              {
                  opacity: 0,
                  y: 30
              },
              {
                  opacity: 1,
                  y: 0,
                  duration: 0.6,
                  stagger: 0.2,
                  ease: "power2.out",
                  onComplete: resolve
              }
          );
      });
  }
  
  updateLoadMoreButton() {
      if (!this.loadMoreBtn) return;
      
      const hiddenArticles = this.container.querySelectorAll('.js-news-article.hidden:not(.filtered)');
      this.loadMoreBtn.style.display = hiddenArticles.length > 0 ? 'block' : 'none';
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const sectionNews = document.querySelector('.custom-section-news');
  if (sectionNews) {
      new BaseNewsSection(sectionNews);
  }
  
  const pageNews = document.querySelector('.custom-page-news');
  if (pageNews) {
      new PageNewsSection(pageNews);
  }
});

/* =============================================
custom-page-collaborations
============================================= */
class collaborationsLoadMore {
  constructor() {
      this.gridWrapper = document.querySelector('.custom-collaborations__grid-wrapper');
      this.articles = document.querySelectorAll('.custom-collaborations__item');
      this.loadMoreButton = document.querySelector('.js-load-more');
      this.displayLimit = 12;
      
      this.init();
  }

  init() {
      if (!this.gridWrapper) return;
      
      if (this.articles.length > this.displayLimit) {
          this.hideExtraArticles();
          this.setupLoadMoreButton();
      } else {
          this.hideLoadMoreButton();
      }
  }

  hideExtraArticles() {
      this.articles.forEach((article, index) => {
          if (index >= this.displayLimit) {
              article.style.display = 'none';
              if (!article.classList.contains('js-fadeIn')) {
                  article.classList.add('js-fadeIn');
              }
          }
      });
  }

  setupLoadMoreButton() {
      if (this.loadMoreButton) {
          this.loadMoreButton.addEventListener('click', this.handleLoadMore.bind(this));
      }
  }

  handleLoadMore() {
      this.articles.forEach((article, index) => {
          if (index >= this.displayLimit) {
              article.style.display = 'block';
              
              // 遅延を付けてフェードイン
              setTimeout(() => {
                  article.style.opacity = '1';
                  article.style.transform = 'translateY(0)';
              }, (index - (this.displayLimit - 1)) * 100);
          }
      });

      this.hideLoadMoreButton();
  }

  hideLoadMoreButton() {
      if (this.loadMoreButton) {
          this.loadMoreButton.style.display = 'none';
      }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new collaborationsLoadMore();
});

/* =============================================
custom-page-collection
============================================= */
class LoadMoreProducts {
  constructor() {
      this.initElements();
  }

  initElements() {
    this.button = document.querySelector('.js-load-more-products');
    this.productsContainer = document.querySelector('#product-grid');
    this.template = document.querySelector('.js-remaining-products');

    if (this.button && this.productsContainer && this.template) {
        this.addClickEvent();
    }
  }

  addClickEvent() {
    // 専用のハンドラ関数を作成して使用
    this.handleClick = this.handleClick || this.loadMore.bind(this);
    
    // 既存のイベントリスナーを削除
    this.button.removeEventListener('click', this.handleClick);
    
    // 新しいイベントリスナーを追加
    this.button.addEventListener('click', this.handleClick);
  }

  loadMore() {
    if (!this.template || !this.productsContainer) {
        console.warn('Required elements not found for loading more products');
        return;
    }

    // テンプレートコンテンツをクローン
    const content = this.template.content.cloneNode(true);
    
    // 明示的にli要素を選択
    const productItems = content.querySelectorAll('li');
    console.log(`追加する商品数: ${productItems.length}個`);
    
    // パフォーマンス向上のためにフラグメントを使用
    const fragment = document.createDocumentFragment();
    const newProducts = [];
    
    // 各商品要素をフラグメントに追加
    productItems.forEach(item => {
        // アニメーション用に初期状態を設定
        item.style.opacity = '0';
        item.style.transform = 'translateY(30px)';
        fragment.appendChild(item);
        newProducts.push(item);
    });
    
    // すべての商品を一度に追加
    this.productsContainer.appendChild(fragment);
    
    // 追加された商品をアニメーション表示
    if (newProducts.length > 0) {
        gsap.to(newProducts, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.1,
            ease: "power2.out"
        });
    }

    if (this.button) {
        const moreWrapper = this.button.closest('.custom-collection__more-wrapper');
        if (moreWrapper) {
            moreWrapper.style.display = 'none';
        }
    }
}
}

// MutationObserverを使用してDOMの変更を監視
const observeDOM = () => {
  const targetNode = document.querySelector('#ProductGridContainer');
  if (!targetNode) return;

  const config = { childList: true, subtree: true };
  const callback = function(mutationsList, observer) {
      for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
              initializeLoadMore();
          }
      }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};

// グローバルインスタンスを保持
let loadMoreInstance = null;

// 初期化関数
function initializeLoadMore() {
  loadMoreInstance = new LoadMoreProducts();
}

// DOMの読み込み完了時に初期化
document.addEventListener('DOMContentLoaded', () => {
  initializeLoadMore();
  observeDOM();
});

// フィルターフォームの送信を監視
document.addEventListener('submit', (e) => {
  if (e.target.id === 'FacetFiltersForm') {
      // フォーム送信後のDOM更新を待つ
      setTimeout(() => {
          console.log('Reinitializing after filter submission');
          initializeLoadMore();
      }, 500);
  }
});

// Shopifyのセクション更新時に再初期化
document.addEventListener('shopify:section:load', () => {
  setTimeout(() => {
      initializeLoadMore();
      observeDOM();
  }, 100);
});
/* =============================================
数量選択
============================================= */
(function() {
  // PUB_SUB_EVENTS定数の確認とフォールバック
  const EVENTS = window.PUB_SUB_EVENTS || {
    variantChange: 'variant:change',
    quantityUpdate: 'quantity:update'
  };

  // 元のproduct-info定義を拡張するためのクラス
  class QuantityDropdownEnhancer {
    constructor() {
      this.init();
    }
    
    init() {
      // product-infoカスタムエレメントのprototypeを拡張
      this.extendProductInfoClass();
      
      // 既存のドロップダウンを初期化
      this.initializeExistingDropdowns();
      
      // DOMの監視を設定
      this.setupMutationObserver();
      
      // イベントリスナー
      document.addEventListener(EVENTS.variantChange, this.handleVariantChange.bind(this));
      document.addEventListener('shopify:section:load', this.handleSectionLoad.bind(this));
    }
    
    extendProductInfoClass() {
      // product-infoカスタムエレメントが定義されているか確認
      const productInfoElement = customElements.get('product-info');
      if (!productInfoElement) {
        setTimeout(() => this.extendProductInfoClass(), 500);
        return;
      }
      
      // 元のconnectedCallbackをバックアップ
      const originalConnectedCallback = productInfoElement.prototype.connectedCallback;
      const originalUpdateQuantityRules = productInfoElement.prototype.updateQuantityRules;
      const originalSetQuantityBoundries = productInfoElement.prototype.setQuantityBoundries;
      
      // connectedCallbackを拡張
      productInfoElement.prototype.connectedCallback = function() {
        // 元の処理を実行
        originalConnectedCallback.apply(this, arguments);
        
        // ドロップダウンを初期化
        initializeQuantityDropdown(this);
      };
      
      // updateQuantityRulesを拡張
      productInfoElement.prototype.updateQuantityRules = function(sectionId, html) {
        // 元の処理を実行
        originalUpdateQuantityRules.apply(this, arguments);
        
        // ドロップダウンを更新
        const quantityDropdown = this.querySelector('select[name="quantity"]');
        if (quantityDropdown) {
          updateDropdownOptions(quantityDropdown, this);
        }
      };
      
      // setQuantityBoundriesを拡張
      productInfoElement.prototype.setQuantityBoundries = function() {
        // 元の処理を実行
        originalSetQuantityBoundries.apply(this, arguments);
        
        // ドロップダウンを更新
        const quantityDropdown = this.querySelector('select[name="quantity"]');
        if (quantityDropdown) {
          updateDropdownOptions(quantityDropdown, this);
        }
      };
    }
    
    initializeExistingDropdowns() {
      const productInfos = document.querySelectorAll('product-info');
      productInfos.forEach(productInfo => {
        initializeQuantityDropdown(productInfo);
      });
    }
    
    setupMutationObserver() {
      const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'PRODUCT-INFO') {
                  initializeQuantityDropdown(node);
                } else {
                  const productInfos = node.querySelectorAll('product-info');
                  productInfos.forEach(productInfo => {
                    initializeQuantityDropdown(productInfo);
                  });
                }
              }
            });
          }
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    
    handleVariantChange(event) {
      // バリアント変更イベントで全てのドロップダウンを更新
      setTimeout(() => {
        const productInfos = document.querySelectorAll('product-info');
        productInfos.forEach(productInfo => {
          const quantityDropdown = productInfo.querySelector('select[name="quantity"]');
          if (quantityDropdown) {
            updateDropdownOptions(quantityDropdown, productInfo);
          }
        });
      }, 50);
    }
    
    handleSectionLoad(event) {
      const section = event.target;
      if (!section) return;
      
      const productInfos = section.querySelectorAll('product-info');
      productInfos.forEach(productInfo => {
        initializeQuantityDropdown(productInfo);
      });
    }
  }
  
  // 個別のドロップダウンを初期化する関数
  function initializeQuantityDropdown(productInfo) {
    const quantityDropdown = productInfo.querySelector('select[name="quantity"]');
    if (!quantityDropdown) return;
    
    // 既に初期化済みならスキップ
    if (quantityDropdown.dataset.enhanced === 'true') return;
    
    // オプションを更新
    updateDropdownOptions(quantityDropdown, productInfo);
    
    // イベントリスナーを設定
    quantityDropdown.addEventListener('change', function(event) {
      const quantity = parseInt(event.target.value, 10);
      
      // 既存の数量入力と同期
      const quantityInput = productInfo.querySelector('.quantity__input');
      if (quantityInput && quantityInput.value !== quantity.toString()) {
        quantityInput.value = quantity;
        
        // イベントをディスパッチ
        if (typeof window.publish === 'function' && EVENTS.quantityUpdate) {
          window.publish(EVENTS.quantityUpdate, undefined);
        } else {
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    
    // 初期化完了としてマーク
    quantityDropdown.dataset.enhanced = 'true';
  }
  
  // ドロップダウンのオプションを更新する関数
  function updateDropdownOptions(dropdown, productInfo) {
    // 現在の値を保持
    const currentValue = parseInt(dropdown.value, 10) || 1;
    
    // 数量の制約を取得
    let constraints = getQuantityConstraints(productInfo);
    
    // オプションを生成
    populateOptions(dropdown, constraints, currentValue);
  }
  
  // 数量の制約を取得する関数
  function getQuantityConstraints(productInfo) {
    let min = 1;
    let max = 20;
    let step = 1;
    let cartQty = 0;
    
    // 数量入力から制約を取得
    const quantityInput = productInfo.querySelector('.quantity__input');
    if (quantityInput) {
      min = parseInt(quantityInput.dataset.min || quantityInput.min || 1, 10);
      max = quantityInput.dataset.max || quantityInput.max ? 
             parseInt(quantityInput.dataset.max || quantityInput.max, 10) : 20;
      step = parseInt(quantityInput.step || 1, 10);
      cartQty = parseInt(quantityInput.dataset.cartQuantity || 0, 10);
    }
    
    // バリアントから情報を取得
    const variantData = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (quantityInput === null && variantData && variantData.textContent) {
      try {
        const variant = JSON.parse(variantData.textContent);
        if (variant.quantity_rule) {
          min = variant.quantity_rule.min || min;
          max = variant.quantity_rule.max || max;
          step = variant.quantity_rule.increment || step;
        }
      } catch (e) {}
    }
    
    // 値の正規化
    min = Math.max(1, min);
    if (!max || max > 100) max = 100;
    step = Math.max(1, step);
    
    return { min, max, step, cartQty };
  }
  
  // オプションを生成する関数
  function populateOptions(dropdown, constraints, currentValue) {
    // 現在のオプション数
    const currentOptionsCount = dropdown.options.length;
    
    // 必要なオプション数を計算
    const { min, max, step } = constraints;
    const optionsCount = Math.floor((max - min) / step) + 1;
    
    // 最適化: オプション数が同じで最小値も同じなら更新しない
    if (currentOptionsCount === optionsCount && 
        dropdown.options[0] && 
        parseInt(dropdown.options[0].value, 10) === min) {
      // 選択値だけ確認して更新
      const valueExists = Array.from(dropdown.options).some(option => 
        parseInt(option.value, 10) === currentValue);
      
      if (valueExists) {
        dropdown.value = currentValue;
        return;
      }
    }
    
    // ドロップダウンをクリア
    dropdown.innerHTML = '';
    
    // オプションを生成
    for (let i = min; i <= max; i += step) {
      const option = document.createElement('option');
      option.value = i;
      option.textContent = i;
      dropdown.appendChild(option);
    }
    
    // 適切な値を選択
    const valueExists = Array.from(dropdown.options).some(option => 
      parseInt(option.value, 10) === currentValue);
    
    if (valueExists) {
      dropdown.value = currentValue;
    } else {
      dropdown.value = min;
    }
  }
  
  // 初期化
  function initialize() {
    new QuantityDropdownEnhancer();
  }
  
  // DOMContentLoaded時に初期化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();

